import { render } from "./KatBadge.vue?vue&type=template&id=e4e658dc&scoped=true"
import script from "./KatBadge.vue?vue&type=script&lang=js"
export * from "./KatBadge.vue?vue&type=script&lang=js"

import "./KatBadge.vue?vue&type=style&index=0&id=e4e658dc&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e658dc"]])

export default __exports__